import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { IHeader, IHeaderAction, IHeaderBadge, IHeaderStatus } from './interfaces';
import { HeaderType } from '@app/modules/app-layout/enums/headerType';
import { InternalNote } from '@shared/internal-notes/interfaces';

@Injectable({ providedIn: 'root' })
export class AppLayoutService {
  public openSidebarMenu$: Subject<boolean> = new Subject();
  public openSettingSidebar$: Subject<boolean> = new Subject();
  public contentHeader$: BehaviorSubject<IHeader> = new BehaviorSubject<IHeader>(null);
  public headerActions$: BehaviorSubject<IHeaderAction[]> = new BehaviorSubject<IHeaderAction[]>([]);
  public headerBadge$: BehaviorSubject<IHeaderBadge> = new BehaviorSubject<IHeaderBadge>(null);
  public headerStatus$: BehaviorSubject<IHeaderStatus> = new BehaviorSubject<IHeaderStatus>(null);
  public headerTypeSource$: BehaviorSubject<number> = new BehaviorSubject<number>(HeaderType.Basic);
  public internalNotes$: BehaviorSubject<InternalNote> = new BehaviorSubject<InternalNote>(null);
  public internalNotesUpdated$: BehaviorSubject<void> = new BehaviorSubject<void>(null);
  public openImportInput$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public recalculateBeforeEdit$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public get currentHeaderStatus(): BehaviorSubject<IHeaderStatus> {
    return this.headerStatus$;
  }
}
